import { STEPS_NAMES } from '@/consts/steps.const';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';

export const Steps = {
  actions,
  mutations,
  getters,
  state: {
    isDataLoading: false,
    error: {
      backend: '',
      translation: '',
    },
    current: STEPS_NAMES.validateBooking,
    steps: {
      [STEPS_NAMES.validateBooking]: {
        email: '',
        confirmEmail: '',
        bookingId: '',
        bookingDate: '',
      },
      [STEPS_NAMES.selectCountry]: {
        selectedCountryName: '',
        selectedCountryCode: '',
      },
      [STEPS_NAMES.selectDocuments]: {
        selectedDocuments: [],
        isDisclaimerChecked: false,
      },
      [STEPS_NAMES.validateDocuments]: {
        token: '',
        applicantId: '',
        documents: [],
        documentsChecksIds: [],
        documentType: '',
      },
      [STEPS_NAMES.updateAddress]: {
        address: '',
        selectedCountry: '',
        province: '',
        cp: '',
        city: '',
        telephone: '',
        prefix: '',
        additionalDriver: false,
        askForAdditionalDriverEmail: false,
        additionalDriverEmail: '',
        countryOfBirth: '',
      },
    },
  },
} as const;
